/**
 * LitlingsMark  -  the Litlings sprout logo mark (SVG).
 * Crisp at any size. Use `size` for px. Optional rounded chip background.
 */

export default function LitlingsMark({
  size = 32,
  chip,
}: {
  size?: number
  chip?: 'cream' | 'navy' | 'orange' | null
}) {
  const chipFill =
    chip === 'navy' ? '#1A237E' : chip === 'orange' ? '#FF7B2C' : chip === 'cream' ? '#FFF7ED' : null

  return (
    <svg width={size} height={size} viewBox="0 0 110 110" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Litlings">
      {chipFill && <rect x="2" y="2" width="106" height="106" rx="26" fill={chipFill} stroke={chip === 'cream' ? '#F0E2CD' : 'none'} strokeWidth="1" />}
      <ellipse cx="55" cy="97" rx="29" ry="6.5" fill="#E6D5BE" />
      <path d="M55,95 C53,79 57,64 55,50" fill="none" stroke="#2E7D43" strokeWidth="6" strokeLinecap="round" />
      <path d="M55,73 C36,73 24,57 20,39 C42,43 53,57 55,73 Z" fill="#4CAF63" stroke="#FFFFFF" strokeWidth="1.5" />
      <path d="M55,73 C74,73 86,57 90,39 C68,43 57,57 55,73 Z" fill="#6FCF85" stroke="#FFFFFF" strokeWidth="1.5" />
      <path d="M55,55 C48,45 50,32 55,24 C60,32 62,45 55,55 Z" fill="#4CAF63" stroke="#FFFFFF" strokeWidth="1.5" />
      <circle cx="86" cy="27" r="6" fill="#FFB23E" />
    </svg>
  )
}
